import * as React from 'react'

const Dashboard = (props: { className: 'string' }) => {
  return (
    <svg className={'icon ' + props.className} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <g id='Canvas'>
        <g id='Dashboard' clipPath='url(#clip0)'>
          <path
            d='M 21.8182 0L 2.18182 0C 0.981818 0 0 1.125 0 2.5L 0 17.5C 0 18.875 0.981818 20 2.18182 20L 7.63636 20L 16.3636 20L 21.8182 20C 23.0182 20 23.9891 18.875 23.9891 17.5L 24 2.5C 24 1.125 23.0182 0 21.8182 0ZM 21.8182 17.5L 2.18182 17.5L 2.18182 2.5L 21.8182 2.5L 21.8182 17.5Z'
            transform='translate(0 2)'
            id='Vector'
          />
          <path
            d='M 3.15 0L 3.15 7C 1.3755 6.825 0 5.3235 0 3.5C 0 1.6765 1.3755 0.175 3.15 0ZM 3.8605 0L 3.8605 3.1465L 7 3.1465C 6.8355 1.4875 5.516 0.1645 3.8605 0ZM 3.8605 3.8535L 3.8605 7C 5.5195 6.8355 6.8355 5.5125 7 3.8535L 3.8605 3.8535Z'
            transform='translate(13 9)'
            id='Vector_2'
          />
          <path
            d='M 2.625 7L 4.375 7L 4.375 0L 2.625 0L 2.625 7ZM 0 7L 1.75 7L 1.75 3.5L 0 3.5L 0 7ZM 5.25 2.1875L 5.25 7L 7 7L 7 2.1875L 5.25 2.1875Z'
            transform='translate(4 9)'
            id='Vector_3'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0'>
          <rect width='24' height='24' fill='#fff' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Dashboard



// WEBPACK FOOTER //
// ./src/components/icons/main-menu/Dashboard.tsx